/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerMiniCartBadgeSX: SxProps = {
	'.MuiBadge-badge': {
		right: 6,
		top: 5,
		borderRadius: '3px',
		minWidth: 'min-content',
		fontSize: '8px',
		color: 'primary.main',
		backgroundColor: 'background.paper',
		padding: '0 2px',
		height: '10px',
	},
};

export const headerMiniCartIconSX: SxProps = {
	color: 'grey.500',
};
